






















































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import VWeekPicker from "@/components/VWeekPicker.vue";
import YearsSelector from "@/components/SpecialInitiatives/YearsSelector.vue";
import VSwitchButton from "@/components/VSwitchButton.vue";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import TaxonomySelect from "@/components/TaxonomySelect.vue";
import FiltersMixin from "@/mixins/SpecialInitiatives/FiltersMixin";
import Broadcaster, {
  BroadcastersCatalog,
  BroadcastersCollection,
} from "@/models/SpecialInitiatives/Broadcaster";
import SpecialInitiatives from "@/services/SpecialInitiavesService";
import { Route } from "vue-router";
import HeatmapTable, {
  HeatmapTableColumn,
  HeatmapTableRow,
} from "@/components/HeatmapTable.vue";
import {
  WeekPickerResult,
  WEEK_PICKER_MODALITY_WEEK_RANGE,
} from "@/interfaces/WeekPickerDataTypes";
import SpecialInitiativesTable, {
  SpecialInitiativesIData,
  SpecialInitiativesIColumn,
  SubjectColumn,
} from "@/components/SpecialInitiatives/SpecialInitiativesTable.vue";
import SpecialInitiativesChart, {
  ChartWeekRange,
} from "@/components/SpecialInitiatives/Chart.vue";
import SelectOption from "@/interfaces/SelectOption";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import VCheckButton from "@/components/VCheckButton.vue";
import MarketMixin from "@/mixins/http/SpecialInitiatives/MarketMixin";

@Component({
  components: {
    VWeekPicker,
    YearsSelector,
    VSwitchButton,
    MultiLevelSelect,
    TaxonomySelect,
    HeatmapTable,
    SpecialInitiativesTable,
    SpecialInitiativesChart,
    VMultiSwitcher,
    VCheckButton,
  },
})
export default class SpecialInitiativesMarket extends Mixins(
  FiltersMixin,
  MarketMixin
) {
  compareYearStart = 0;
  compareYearEnd = 0;
  disabled = false;

  broadcasters: BroadcastersCatalog = {};

  heatmapColumns: HeatmapTableColumn[] = [];
  heatmapRows: HeatmapTableRow[] = [];
  loading = false;
  chartItems: any[] = [];

  private chartTypeItems: Array<SelectOption> = [
    { id: "bar", text: "Barre" },
    { id: "line", text: "Linea" },
    { id: "pie", text: "Torta", disabled: true },
  ];

  chart = {
    settings: {
      stacked: false,
      percentage: false,
      type: "bar",
    },
  };

  @Watch("heatmapRows")
  onHeatmapRowsChanged() {
    this.buildRowsForChart();
  }

  @Watch("subject")
  onSubjectChanged() {
    this.buildRowsForChart();
  }

  async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    this.loading = true;
    if (this.forceReloadFromApi) {
      await this.loadBroadcasters();
    }
    this.forceReloadFromApi = false;
    this.initData();
    this.loading = false;
    next();
  }

  broadcastersToTableData(): SpecialInitiativesIData {
    const result: SpecialInitiativesIData = {};
    for (const weekRange in this.broadcasters) {
      result[weekRange] = this.broadcastersFromExclusivity(
        this.broadcasters[weekRange],
        this.exclusivity
      );
    }
    return result;
  }

  specialInitiativesWeekRanges(): SpecialInitiativesIColumn[] {
    const weekRanges: SpecialInitiativesIColumn[] = [];
    for (const weekRange in this.broadcasters) {
      weekRanges.push({
        name: `col-${weekRange}`,
        label: this.weekRangeToLabel(weekRange),
      });
    }
    return weekRanges;
  }

  tableSubject(): SubjectColumn {
    if (this.marketSubject) {
      return this.marketSubject as SubjectColumn;
    }
    return "market_segments" as SubjectColumn;
  }

  tableQuoted() {
    return this.unitOfMeasurement?.startsWith("quoted");
  }

  weekRangesLabels(): ChartWeekRange[] {
    return Object.keys(this.broadcasters).map((weekRange) => {
      return {
        label: this.weekRangeToLabel(weekRange),
        columnName: `col-${weekRange}`,
      };
    });
  }

  get heatmapSortColumn() {
    if (this.heatmapColumns.length > 0) {
      return this.heatmapColumns[1];
    } else {
      return null;
    }
  }

  get shouldShowHeatmap() {
    return this.marketSubject === "broadcasters";
  }

  get title() {
    const subject = this.marketSubjectsEntries.find(
      (element) => element.id === this.marketSubject
    );
    return `Overview ${subject?.text?.toLowerCase()}`;
  }

  get currentUnitOfMeasurement(): string {
    if (this.unitOfMeasurement) {
      return (
        this.unitOfMeasurementsEntries.find(
          (e) => e.id === this.unitOfMeasurement
        )?.text || ""
      );
    } else {
      return "";
    }
  }

  get currentIdUnitOfMeasurement(): string {
    if (this.unitOfMeasurement) {
      return (
        this.unitOfMeasurementsEntries.find(
          (e) => e.id === this.unitOfMeasurement
        )?.id || ""
      );
    } else {
      return "";
    }
  }

  get noData(): boolean {
    const keys = Object.keys(this.broadcasters);
    let result = true;
    keys.forEach((key) => {
      result =
        result &&
        this.broadcastersFromExclusivity(
          this.broadcasters[key],
          this.exclusivity
        ).length === 0;
    });
    return result;
  }

  compareYearToDisable(): number {
    if (this.filters.weekRange) {
      const yearCompareFilter = this.filters.weekRange.split(",");
      return Number.parseInt(yearCompareFilter[3]);
    }
    return 0;
  }

  async mounted() {
    this.loading = true;
    this.initCompareYearsRange();
    await this.initFilters();
    await this.loadBroadcasters();
    this.initData();
    this.loading = false;
  }

  async loadBroadcastersFromApi(weekRange: string) {
    const filter = this.filtersForAPI("market");
    filter.weekRange = weekRange;
    const broadcastersAll = await SpecialInitiatives.getBroadcasters(filter);

    this.broadcasters[weekRange] = broadcastersAll.reduce(
      (acc, broadcaster) => {
        switch (broadcaster.exclusivityType) {
          case "mine":
            acc.broadcastersMine.push(broadcaster);
            break;
          case "others":
            acc.broadcastersOthers.push(broadcaster);
            break;
          case "shared":
            acc.broadcastersShared.push(broadcaster);
        }
        return acc;
      },
      {
        broadcastersAll,
        broadcastersMine: [] as Broadcaster[],
        broadcastersOthers: [] as Broadcaster[],
        broadcastersShared: [] as Broadcaster[],
      }
    );
  }

  async loadBroadcasters() {
    this.loading = true;
    this.broadcasters = {};
    const filter = this.filtersForAPI("market");
    if (filter.weekRange) {
      await this.loadBroadcastersFromApi(filter.weekRange);
      if (this.yearsToCompare && this.yearsToCompare.length > 0) {
        const weekRanges = this.compareYearsToWeekRanges();
        for (const weekRange of weekRanges) {
          await this.loadBroadcastersFromApi(weekRange);
        }
      }
    }
    this.loading = false;
  }

  private compareYearsToWeekRanges(): string[] {
    const filter = this.filtersForAPI("market");
    const weekRanges: string[] = [];
    if (
      filter.weekRange &&
      this.yearsToCompare &&
      this.yearsToCompare.length > 0
    ) {
      const [w1, y1, w2, y2] = filter.weekRange.split(",");
      const baseYearEnd = Number.parseInt(y2);
      const baseYearStart = Number.parseInt(y1);
      const yearsToCompare = [...this.yearsToCompare];
      for (const year of yearsToCompare.reverse()) {
        const cmpYear = Number.parseInt(year);
        const compareResult = cmpYear - baseYearEnd;
        if (compareResult != 0) {
          const compareWeekRange = [
            w1,
            `${baseYearStart + compareResult}`,
            w2,
            `${baseYearEnd + compareResult}`,
          ];
          weekRanges.push(compareWeekRange.join(","));
        }
      }
    }
    return weekRanges;
  }

  private arrangeDataInTables() {
    const database: { [key: string]: any } = {};
    for (const weekRange in this.broadcasters) {
      const collection = this.broadcasters[weekRange];
      const broadcasters = this.broadcastersFromExclusivity(
        collection,
        this.exclusivity
      );
      const total = this.getTotals(broadcasters);
      broadcasters.forEach((broadcaster) => {
        const row = database[broadcaster.brandName] || {
          subject: broadcaster.name + "::" + broadcaster.logoUrls[0],
        };
        row[`col-${weekRange}`] = this.cellValue(total, broadcaster);
        database[broadcaster.brandName] = row;
      });
    }
    this.heatmapRows = [];
    for (const subject in database) {
      const row: any = {};
      row["subject"] = subject;

      this.heatmapColumns.forEach((column) => {
        row[column.name] =
          database[subject][column.name] || this.cellZeroValue();
      });
      this.heatmapRows.push(row);
    }
  }

  private getTotals(broadcasters: Broadcaster[]) {
    const fieldName = this.columnFromUnitOfMeasurement();
    if (fieldName === "companiesCount") {
      const companyIdsSet: Set<string> = new Set();
      broadcasters.reduce((acc, broadcaster) => {
        const companyIdsSplitted = broadcaster.companyIds.split(",");
        companyIdsSplitted.forEach((companyId) => {
          acc.add(companyId);
        });
        return acc;
      }, companyIdsSet);
      return companyIdsSet.size;
    } else {
      return broadcasters.reduce((acc, broadcaster) => {
        return acc + broadcaster[fieldName];
      }, 0);
    }
  }

  private initData() {
    this.heatmapColumns = [
      {
        name: "subject",
        label: "Soggetto",
        heatmapDisabled: true,
        locked: true,
      },
    ];
    for (const weekRange in this.broadcasters) {
      this.heatmapColumns.push({
        name: `col-${weekRange}`,
        label: this.weekRangeToLabel(weekRange),
      });
    }
    this.arrangeDataInTables();
  }

  private cellValue(total: number, broadcaster: Broadcaster) {
    const cellValue = broadcaster[this.columnFromUnitOfMeasurement()];

    if (
      this.unitOfMeasurement == "quoted_seconds" ||
      this.unitOfMeasurement == "quoted_spots"
    ) {
      return {
        type: "quoted",
        value: cellValue,
        quote: this.cellQuoteFromTotal(total, broadcaster),
      };
    }
    return cellValue;
  }

  private cellZeroValue() {
    if (
      this.unitOfMeasurement == "quoted_seconds" ||
      this.unitOfMeasurement == "quoted_spots"
    ) {
      return {
        type: "quoted",
        value: 0,
        quote: 0,
      };
    }
    return 0;
  }

  private cellQuoteFromTotal(total: number, broadcaster: Broadcaster) {
    const cellValue = broadcaster[this.columnFromUnitOfMeasurement()];
    return `${cellValue} (${Number((cellValue / total) * 100).toFixed(0)} %)`;
  }

  private columnFromUnitOfMeasurement() {
    if (
      this.unitOfMeasurement === "seconds" ||
      this.unitOfMeasurement === "quoted_seconds"
    ) {
      return "secondsCount";
    } else if (
      this.unitOfMeasurement === "spots" ||
      this.unitOfMeasurement === "quoted_spots"
    ) {
      return "detectionsCount";
    } else {
      return "companiesCount";
    }
  }

  private weekRangeToLabel(weekRange: string) {
    if (weekRange) {
      const [w1, y1, w2, y2] = weekRange.split(",");
      const weekPickerRange: WeekPickerResult = {
        type: WEEK_PICKER_MODALITY_WEEK_RANGE,
        start: {
          week: Number.parseInt(w1),
          year: Number.parseInt(y1),
        },
        end: {
          week: Number.parseInt(w2),
          year: Number.parseInt(y2),
        },
      };
      return `Settimane ${VWeekPicker.resultToHumanReadable(weekPickerRange)}`;
    }
    return "";
  }

  private dateRangeDestructured(dateRange: WeekPickerResult) {
    if (dateRange?.type === WEEK_PICKER_MODALITY_WEEK_RANGE) {
      return [
        dateRange.start.week,
        dateRange.start.year,
        dateRange.end.week,
        dateRange.end.year,
      ];
    } else return [0, 0, 0, 0];
  }

  private initCompareYearsRange() {
    this.compareYearStart = this.$moment().year();
    this.compareYearEnd = this.compareYearStart - this.compareYearsRange;
  }

  private buildRowsForChart(): void {
    if (this.shouldShowHeatmap) {
      const res = this.heatmapRows.map((row) => {
        const rowObj: any = {};
        Object.keys(row).map((key) => {
          const rowItem = row[key];
          if (key.startsWith("col-")) {
            if (rowItem.value) {
              rowObj[key] = rowItem.value;
            } else {
              rowObj[key] = rowItem;
            }
          }
          if (key.startsWith("subject")) {
            rowObj[key] = rowItem;
          }
        });
        return rowObj;
      });
      this.chartItems = res;
    } else {
      this.buildSpecialInitiativesColumnsAndRows(
        this.loading,
        this.exclusivity,
        this.tableSubject(),
        this.broadcasters,
        this.specialInitiativesWeekRanges(),
        this.currentIdUnitOfMeasurement
      );
      const res = this.rows
        .filter((row) => !row.subject.startsWith("TOTALE"))
        .map((row) => {
          const rowObj: any = {};
          Object.keys(row.data).map((key) => {
            const rowItem = row.data[key];
            if (key.startsWith("col-")) {
              if (rowItem.value) {
                rowObj[key] = rowItem.value;
              } else {
                rowObj[key] = rowItem;
              }
            }
          });
          rowObj["subject"] = row.subject;
          return rowObj;
        });
      this.chartItems = res;
    }
  }

  private parseSubjectNameAndLogo(name: string) {
    const match = name.match(/(.*)::(.*)/);
    if (match) {
      return {
        name: match[1],
        logo: match[2],
      };
    } else return name;
  }
}
